import { Col, Layout, Row } from "antd";

const { Footer } = Layout;

const MenuFooter = () => {
  return (
    <Footer className="da-bg-color-black-10 da-bg-color-dark-100 footer">
      <Row align="middle" justify="space-between">
        <Col md={12} span={24}>
          <p className="da-badge-text da-mb-0 da-text-color-dark-30">
            COPYRIGHT ©{(new Date().getFullYear())} ERIS LIFESCIENCES LIMITED, All rights Reserved
          </p>
        </Col>

        <Col
          md={12}
          span={24}
          className="da-mt-sm-8 da-text-sm-center da-text-right"
        >
          {/* <p className="da-badge-text da-text-color-dark-30">🥁 Version: 1.0</p> */}
          <p className="da-badge-text da-text-color-dark-30">Version: {process.env.REACT_APP_VERSION_CODE}</p>
        </Col>
      </Row>
    </Footer>
  );
};

export default MenuFooter;
